/**
 * COMPONENT - Clase Base para Componentes de la Casa
 * Todos los componentes heredan de esta clase
 */

export default class Component {
  constructor(scene, config) {
    this.scene = scene;
    this.id = config.id;
    this.name = config.name;
    this.type = config.type; // 'simple' o 'multi'
    this.icon = config.icon;
    this.color = config.color;
    this.integrityValue = config.integrityValue;
    this.critical = config.critical || false;
    this.damageTypes = config.damageTypes || ['crack'];
    this.maxDamage = config.maxDamage || 1;
    
    this.damages = []; // Array de daños activos
    this.isDestroyed = false;
  }

  /**
   * Agregar daño al componente
   * @param {object} damage
   */
  addDamage(damage) {
    if (this.damages.length < this.maxDamage) {
      this.damages.push(damage);
      this.onDamageAdded(damage);
      return true;
    }
    return false;
  }

  /**
   * Remover daño del componente
   * @param {number} damageId
   */
  removeDamage(damageId) {
    const index = this.damages.findIndex(d => d.id === damageId);
    if (index !== -1) {
      const removed = this.damages.splice(index, 1)[0];
      this.onDamageRemoved(removed);
      return removed;
    }
    return null;
  }

  /**
   * Verificar si tiene daños
   * @returns {boolean}
   */
  hasDamage() {
    return this.damages.length > 0;
  }

  /**
   * Verificar si está en máximo de daños
   * @returns {boolean}
   */
  isAtMaxDamage() {
    return this.damages.length >= this.maxDamage;
  }

  /**
   * Obtener cantidad de daños
   * @returns {number}
   */
  getDamageCount() {
    return this.damages.length;
  }

  /**
   * Reparar (remover todos los daños)
   */
  repair() {
    const repairedCount = this.damages.length;
    this.damages = [];
    this.onRepaired(repairedCount);
    return repairedCount;
  }

  /**
   * Callback cuando se agrega daño
   */
  onDamageAdded(damage) {
    console.log(`💥 Daño agregado a ${this.name}:`, damage.type.name);
  }

  /**
   * Callback cuando se remueve daño
   */
  onDamageRemoved(damage) {
    console.log(`✅ Daño removido de ${this.name}:`, damage.type.name);
  }

  /**
   * Callback cuando se repara completamente
   */
  onRepaired(count) {
    console.log(`🔧 ${this.name} reparado (${count} daños)"`);
  }

  /**
   * Destruir el componente
   */
  destroy() {
    this.damages = [];
    this.isDestroyed = true;
    this.scene = null;
  }
}
